export default "__VITE_ASSET__BpR4wI9N__ 400w, __VITE_ASSET__COAGSeQn__ 800w, __VITE_ASSET__Bk5l60MI__ 1024w";